import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assignTemplate, changeAssignedTemplate, unassignTemplate } from '../services/templateAssignments';
import type { AssignTemplateInput, ChangeAssignedTemplateInput } from '../types/templateAssignments.types';
import { templateAssignmentKeys } from './templateAssignmentKeys';

function useInvalidateAssignments() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: templateAssignmentKeys.all });
}

export const useAssignTemplateMutation = () => {
  const invalidate = useInvalidateAssignments();
  return useMutation({
    mutationFn: (input: AssignTemplateInput) => assignTemplate(input),
    onSuccess: invalidate,
  });
};

export const useChangeAssignedTemplateMutation = () => {
  const invalidate = useInvalidateAssignments();
  return useMutation({
    mutationFn: (input: ChangeAssignedTemplateInput) => changeAssignedTemplate(input),
    onSuccess: invalidate,
  });
};

export const useUnassignTemplateMutation = () => {
  const invalidate = useInvalidateAssignments();
  return useMutation({
    mutationFn: (assignmentId: string) => unassignTemplate(assignmentId),
    onSuccess: invalidate,
  });
};
